// @ts-check
'use_strict';

export function init() {
    if (document.getElementsByClassName('my-gallery').length > 0) {
        import('./ImageGallery').then(
            // Add HTML necessary for PhotoSwipe.
            module => $.ceAjax(
                'request',
                'index.php?dispatch=tv_utils.get_photoswipe_tpl',
                {
                    'result_ids': 'js-init-photoswipe',
                    'full_render': true,
                    'method': 'POST',
                    'caching': false,
                    'callback': () => {
                        new module.ImageGallery('.my-gallery');
                    }
                }
            )
        );
    }
}
    